(function () {
  function SvgChartGlobal() {}

  SvgChartGlobal.FILE_NAME = "main.js";
  SvgChartGlobal.language = "jp";
  SvgChartGlobal.path = null;
  SvgChartGlobal.lang = {};
  SvgChartGlobal.timeformat = {};

  SvgChartGlobal.getParam = function (key) {
    var uri = window.location.href;
    var re = new RegExp(key + "=([^&?]*)", "ig");
    return uri.match(re) ? uri.match(re)[0].substr(key.length + 1) : null;
  };

  document.addEventListener("mouseup", function (e) {
    if (window.current_scrolling_target != undefined && e.button == 0) {
      window.current_scrolling_target.scrollActionStatus = null;
      window.current_scrolling_target = null;
    }
  });

  Date.prototype.toISOString = function () {
    function pad(n) {
      return n < 10 ? "0" + n : n;
    }
    return (
      this.getUTCFullYear() +
      "/" +
      pad(this.getUTCMonth() + 1) +
      "/" +
      pad(this.getUTCDate()) +
      " " +
      pad(this.getUTCHours()) +
      ":" +
      pad(this.getUTCMinutes()) +
      ":" +
      pad(this.getUTCSeconds()) +
      " +00"
    );
  };

  window.MST = SvgChartGlobal;
})();
